/*
 * @Description: 
 * @Author: zhanghang
 * @Date: 2022-11-28 13:54:27
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-07-28 17:26:00
 */
export default {
  install(Vue) {
    Vue.directive("dataview-unit", function (el, bind) {
      let value = bind.value
      let args = bind.arg
      //unit 换算单位
      //isUnit 是否显示换算单位
      //decimalNum 小数保留位数
      //divider 千位分割符号
      let { unit, isUnit, decimalNum, divider, position = "before" } = args
      value = dsf.dataview.utils.transformUnit(value, unit, isUnit, decimalNum, divider)

      $(el).find('.dataview-unit-span').remove()
      if (position === 'before') {
        $(el).prepend(`<span class="dataview-unit-span">${value}</span>`)
      } else {
        $(el).append(`<span class="dataview-unit-span">${value}</span>`)
      }

    });
  }
};